import EmailFooterV2 from '../components/FooterV2';

interface EmailProps {
  userName: string
  courseName: string
  courseDate: string
  courseDuration: string
  oldInstructor: string
  newInstructor: string
  modality: string
  courseId: string
  session: string
  time: string
  address: string
  meetingLink: string
  companyName: string
  changeReason?: string
  newInstructorBio?: string
  newInstructorExperience?: string
  supportEmail?: string
  supportPhone?: string
}

export default function InstructorChangeNotificationEmail({
  userName = "João Silva",
  courseName = "Fundamentos de Data Analytics",
  courseDate = "15 de abril de 2025",
  courseDuration = "120 minutos",
  oldInstructor = "Ana Carolina Soares",
  newInstructor = "Dr. Roberto Martins",
  modality = "Híbrido",
  courseId = "FA-2025-001",
  session = "1ª aula",
  time = "06:00 às 14:00",
  address = "Av. Paulista, 1000 - Sala 203, São Paulo - SP",
  meetingLink = "https://teams.microsoft.com/l/meetup-join/19%3ameeting_abc123@thread.v2/",
  companyName = "Empresa XYZ Ltda",
  changeReason = "Indisponibilidade por compromissos acadêmicos",
  newInstructorBio = "Especialista em Data Science com 15 anos de experiência em análise de dados e machine learning",
  newInstructorExperience = "PhD em Ciência da Computação, ex-Google, autor de 3 livros sobre Analytics",
  supportEmail = "suporte@trivium.com.br",
  supportPhone = "(11) 3181-5940",
}: EmailProps) {
  return (
    <div style={{ margin: 0, padding: 0, fontFamily: "Arial, sans-serif", backgroundColor: "#ffffff" }}>
      {/* Responsive CSS Styles */}
      <style dangerouslySetInnerHTML={{
        __html: `
          @media only screen and (max-width: 600px) {
            .email-container { width: 100% !important; max-width: 100% !important; border-radius: 0 !important; }
            .body-content { padding: 24px 20px !important; }
            .header { padding: 16px !important; }
            .logo { width: 100px !important; }
            .title { font-size: 20px !important; margin: 12px 0 4px !important; }
            .subtitle { font-size: 14px !important; margin: 0 0 20px !important; }
            .badge { font-size: 12px !important; padding: 6px 12px !important; }
            .card { padding: 12px !important; margin-bottom: 6px !important; }
            .card-label { font-size: 11px !important; }
            .card-value { font-size: 14px !important; }
            .section-title { font-size: 16px !important; margin: 20px 0 8px !important; }
            .info-box { padding: 16px !important; }
            .info-box h3 { font-size: 15px !important; }
            .info-box p { font-size: 13px !important; }
            .info-list { font-size: 13px !important; }
            .btn { display: block !important; width: 100% !important; text-align: center !important; margin-bottom: 8px !important; }
            .btn-primary { padding: 14px 16px !important; font-size: 15px !important; }
            .list, .warning-list { font-size: 13px !important; padding-left: 16px !important; }
            .contact-box { padding: 16px !important; }
            .contact-title { font-size: 15px !important; }
            .contact-info { font-size: 13px !important; }
            .footer { padding: 20px 16px !important; }
            .footer-logo { width: 70px !important; }
            .social-icons { justify-content: center !important; gap: 20px !important; }
            .social-icon { width: 24px !important; height: 24px !important; }
            .change-highlight { padding: 12px !important; }
            .instructor-comparison { padding: 12px !important; }
            .old-instructor { padding: 12px !important; }
            .new-instructor { padding: 12px !important; }
          }
          @media only screen and (max-width: 480px) {
            .body-content { padding: 20px 16px !important; }
            .title { font-size: 18px !important; }
            .subtitle { font-size: 13px !important; }
            .card { padding: 10px !important; }
            .card-label { font-size: 10px !important; }
            .card-value { font-size: 13px !important; }
            .section-title { font-size: 15px !important; }
            .info-box { padding: 14px !important; }
            .btn-primary { padding: 12px 14px !important; font-size: 14px !important; }
            .social-icons { gap: 16px !important; }
            .social-icon { width: 22px !important; height: 22px !important; }
            .change-highlight { padding: 10px !important; }
            .instructor-comparison { padding: 10px !important; }
            .old-instructor { padding: 10px !important; }
            .new-instructor { padding: 10px !important; }
          }
        `
      }} />
      
      <table
        width="100%"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ backgroundColor: "#ffffff", padding: "40px 0" }}
      >
        <tbody>
          <tr>
            <td align="center">
              <table
                className="email-container"
                width={600}
                border={0}
                cellSpacing={0}
                cellPadding={0}
                style={{ 
                  backgroundColor: "#FAFAFA", 
                  borderRadius: "12px", 
                  overflow: "hidden",
                  maxWidth: "600px",
                  margin: "0 auto"
                }}
              >
                <tbody>
                  {/* Header */}
                  <tr>
                    <td 
                      className="header"
                      align="center" 
                      style={{ 
                        backgroundColor: "#1F1746", 
                        padding: "20px",
                        textAlign: "center"
                      }}
                    >
                      <div style={{ textAlign: "center", width: "100%" }}>
                        <img
                          className="logo"
                          src="https://asset.brandfetch.io/idNdb_MPJ2/idFGj2lq6u.png?c=1dxbfHSJFAPEGdCLU4o5B"
                          alt="Logo Trivium"
                          width={120}
                          style={{ 
                            display: "block", 
                            width: "120px", 
                            height: "auto",
                            margin: "0 auto"
                          }}
                        />
                      </div>
                    </td>
                  </tr>

                  {/* Body */}
                  <tr>
                    <td 
                      className="body-content"
                      style={{ 
                        padding: "36px 30px", 
                        color: "#333333"
                      }}
                    >
                      {/* Badge + Title */}
                      <div style={{ textAlign: "center" }}>
                        <span
                          className="badge"
                          style={{
                            backgroundColor: "#e0f2fe",
                            color: "#0369a1",
                            display: "inline-block",
                            padding: "8px 16px",
                            borderRadius: "999px",
                            fontSize: "13px",
                            fontWeight: 700,
                            marginBottom: "16px"
                          }}
                        >
                          👨‍🏫 Alteração de Instrutor
                        </span>
                        <h1 
                          className="title"
                          style={{ 
                            fontSize: "24px", 
                            margin: "16px 0 6px", 
                            color: "#111111",
                            lineHeight: "1.3"
                          }}
                        >
                          Olá, {userName} 👋
                        </h1>
                        <p 
                          className="subtitle"
                          style={{ 
                            fontSize: "16px", 
                            margin: "0 0 24px", 
                            color: "#555555", 
                            lineHeight: "1.6"
                          }}
                        >
                          Informamos uma alteração no instrutor da formação
                          <br />
                          <strong>{courseName}</strong>
                        </p>
                      </div>

                      {/* Destaque da Alteração */}
                      <div
                        className="change-highlight"
                        style={{
                          background: "linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)",
                          border: "2px solid #0ea5e9",
                          borderRadius: "12px",
                          padding: "20px",
                          marginBottom: "24px",
                          textAlign: "center"
                        }}
                      >
                        <h2 style={{ 
                          fontSize: "18px", 
                          color: "#0369a1", 
                          margin: "0 0 16px",
                          fontWeight: "bold"
                        }}>
                          🔄 Mudança de Instrutor
                        </h2>
                        <p style={{ 
                          fontSize: "14px", 
                          color: "#0369a1", 
                          margin: 0,
                          lineHeight: "1.5"
                        }}>
                          Temos uma atualização importante sobre o instrutor da sua formação.
                        </p>
                      </div>

                      {/* Comparação de Instrutores */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 16px",
                          lineHeight: "1.3"
                        }}
                      >
                        👥 Alteração do Instrutor
                      </h2>

                      <table width="100%" cellPadding={0} cellSpacing={0} style={{ marginBottom: "24px" }}>
                        <tbody>
                          <tr>
                            <td width="50%" style={{ padding: "8px" }}>
                              {/* Instrutor Anterior */}
                              <div
                                className="old-instructor"
                                style={{
                                  background: "#fef2f2",
                                  border: "2px solid #fca5a5",
                                  borderRadius: "10px",
                                  padding: "16px"
                                }}
                              >
                                <h3 style={{ 
                                  fontSize: "14px", 
                                  color: "#dc2626", 
                                  margin: "0 0 12px",
                                  fontWeight: "bold",
                                  textAlign: "center"
                                }}>
                                  👋 Instrutor Anterior
                                </h3>
                                <div style={{ textAlign: "center" }}>
                                  <div style={{ 
                                    fontSize: "16px", 
                                    color: "#7f1d1d",
                                    fontWeight: "bold",
                                    textDecoration: "line-through"
                                  }}>
                                    {oldInstructor}
                                  </div>
                                  {changeReason && (
                                    <div style={{ 
                                      fontSize: "12px", 
                                      color: "#dc2626",
                                      marginTop: "8px",
                                      fontStyle: "italic"
                                    }}>
                                      Motivo: {changeReason}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td width="50%" style={{ padding: "8px" }}>
                              {/* Novo Instrutor */}
                              <div
                                className="new-instructor"
                                style={{
                                  background: "#f0fdf4",
                                  border: "2px solid #86efac",
                                  borderRadius: "10px",
                                  padding: "16px"
                                }}
                              >
                                <h3 style={{ 
                                  fontSize: "14px", 
                                  color: "#16a34a", 
                                  margin: "0 0 12px",
                                  fontWeight: "bold",
                                  textAlign: "center"
                                }}>
                                  ✨ Novo Instrutor
                                </h3>
                                <div style={{ textAlign: "center" }}>
                                  <div style={{ 
                                    fontSize: "16px", 
                                    color: "#14532d",
                                    fontWeight: "bold"
                                  }}>
                                    {newInstructor}
                                  </div>
                                  <div style={{ 
                                    fontSize: "12px", 
                                    color: "#16a34a",
                                    marginTop: "8px",
                                    fontStyle: "italic"
                                  }}>
                                    Seu novo instrutor especialista
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      {/* Perfil do Novo Instrutor */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3"
                        }}
                      >
                        🎓 Conheça Seu Novo Instrutor
                      </h2>
                      <div
                        className="info-box"
                        style={{
                          background: "#f0fdf4",
                          border: "2px solid #22c55e",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "16px"
                        }}
                      >
                        <h3 style={{ margin: "0 0 8px", fontSize: "18px", color: "#16a34a", fontWeight: "bold" }}>
                          👨‍🏫 {newInstructor}
                        </h3>
                        {newInstructorBio && (
                          <p style={{ margin: "0 0 12px", fontSize: "14px", color: "#374151", lineHeight: "1.6" }}>
                            <strong>Sobre:</strong> {newInstructorBio}
                          </p>
                        )}
                        {newInstructorExperience && (
                          <p style={{ margin: "0", fontSize: "14px", color: "#374151", lineHeight: "1.6" }}>
                            <strong>Experiência:</strong> {newInstructorExperience}
                          </p>
                        )}
                      </div>

                      {/* Informações da Formação */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3"
                        }}
                      >
                        📚 Informações da Formação
                      </h2>
                      <div
                        className="info-box"
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "16px"
                        }}
                      >
                        <h3 style={{ margin: "0 0 4px", fontSize: "16px", color: "#1F1746" }}>{courseName}</h3>
                        <p style={{ margin: "0 0 14px", fontSize: "14px", color: "#6b7280" }}>Analytics Essentials</p>
                        <table 
                          width="100%" 
                          cellPadding={0} 
                          cellSpacing={0} 
                          className="info-list"
                          style={{ fontSize: "14px", color: "#111" }}
                        >
                          <tbody>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                🔖 <strong>ID da aula:</strong> {courseId}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                📌 <strong>Sessão:</strong> {session}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                📅 <strong>Data:</strong> {courseDate}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                🕓 <strong>Horário:</strong> {time}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                ⏳ <strong>Duração:</strong> {courseDuration}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                🌍 <strong>Modalidade:</strong> {modality}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* Local e Reunião */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3"
                        }}
                      >
                        📍 Local e Reunião
                      </h2>
                      <div
                        className="info-box"
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "16px"
                        }}
                      >
                        <p style={{ margin: "0 0 8px", fontSize: "14px", color: "#111" }}>
                          📌 <strong>Endereço:</strong> {address}
                        </p>
                        <p style={{ margin: "0 0 16px", fontSize: "14px", color: "#111" }}>
                          💻 <strong>Microsoft Teams</strong>
                        </p>
                        <div style={{ textAlign: "center" }}>
                          <a
                            href={meetingLink}
                            className="btn btn-primary"
                            style={{
                              backgroundColor: "#3b65f5",
                              color: "#ffffff",
                              textDecoration: "none",
                              padding: "12px 18px",
                              borderRadius: "8px",
                              fontSize: "14px",
                              fontWeight: "bold",
                              display: "inline-block",
                              cursor: "pointer",
                              transition: "background-color 0.3s ease",
                              maxWidth: "100%",
                              boxSizing: "border-box"
                            }}
                          >
                            Participar da Reunião
                          </a>
                        </div>
                      </div>

                      {/* Organização */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3"
                        }}
                      >
                        🏢 Organização
                      </h2>
                      <div
                        className="info-box"
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "16px"
                        }}
                      >
                        <h3 style={{ margin: "0 0 6px", fontSize: "15px", color: "#1F1746" }}>{companyName}</h3>
                        <p style={{ margin: 0, fontSize: "13px", color: "#4b5563" }}>
                          🤝 Esta formação é uma iniciativa do {companyName}, em parceria com a Trivium.
                        </p>
                      </div>

                      {/* Próximos passos */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3"
                        }}
                      >
                        📝 Próximos Passos
                      </h2>
                      <div
                        className="info-box"
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "16px"
                        }}
                      >
                        <ul
                          className="list"
                          style={{
                            fontSize: "14px",
                            color: "#4b5563",
                            lineHeight: "1.8",
                            paddingLeft: "20px",
                            margin: 0
                          }}
                        >
                          <li style={{ marginBottom: "8px" }}>👨‍🏫 Conheça o perfil do novo instrutor acima</li>
                          <li style={{ marginBottom: "8px" }}>✅ Teste sua conexão antes da aula</li>
                          <li style={{ marginBottom: "8px" }}>✅ Instale o Microsoft Teams</li>
                          <li style={{ marginBottom: "8px" }}>✅ Prepare perguntas e anotações</li>
                          <li style={{ marginBottom: "8px" }}>📚 Revise o material preparatório se disponível</li>
                        </ul>
                      </div>

                      {/* Informações importantes */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "18px 0 10px",
                          lineHeight: "1.3"
                        }}
                      >
                        💡 Informações Importantes
                      </h2>
                      <div
                        className="warning-box"
                        style={{
                          background: "#e0f2fe",
                          border: "1px solid #0ea5e9",
                          borderRadius: "10px",
                          padding: "18px"
                        }}
                      >
                        <ul
                          className="warning-list"
                          style={{
                            fontSize: "14px",
                            color: "#374151",
                            lineHeight: "1.9",
                            paddingLeft: "20px",
                            margin: 0
                          }}
                        >
                          <li style={{ marginBottom: "8px" }}>👨‍🏫 <strong>IMPORTANTE:</strong> O instrutor foi alterado de <span style={{ textDecoration: "line-through", color: "#dc2626" }}>{oldInstructor}</span> para <span style={{ color: "#16a34a", fontWeight: "bold" }}>{newInstructor}</span></li>
                          <li style={{ marginBottom: "8px" }}>📚 O conteúdo e qualidade da formação permanecem os mesmos</li>
                          <li style={{ marginBottom: "8px" }}>⏰ Data, horário e local permanecem inalterados</li>
                          <li style={{ marginBottom: "8px" }}>🎧 Teste seu áudio e vídeo antes do início da aula</li>
                          <li style={{ marginBottom: "8px" }}>🔗 Tenha o link da reunião salvo para acesso rápido</li>
                          <li style={{ marginBottom: "8px" }}>📜 Ao final do encontro, você receberá um certificado de participação</li>
                          <li style={{ marginBottom: "8px" }}>✉️ Em caso de dúvidas, entre em contato conosco</li>
                        </ul>
                      </div>

                      {/* Contato de suporte */}
                      <div
                        className="contact-box"
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: "10px",
                          padding: "18px",
                          background: "#ffffff",
                          margin: "20px 0",
                          textAlign: "center"
                        }}
                      >
                        <h2 
                          className="contact-title"
                          style={{ 
                            fontSize: "16px", 
                            color: "#111", 
                            margin: "0 0 10px"
                          }}
                        >
                          🤝 Precisa de ajuda? Entre em contato conosco:
                        </h2>
                        <p 
                          className="contact-info"
                          style={{ 
                            margin: 0, 
                            fontSize: "14px", 
                            color: "#374151", 
                            lineHeight: "1.6"
                          }}
                        >
                          ✉️ {supportEmail}
                          <br />📱 {supportPhone}
                        </p>
                      </div>
                    </td>
                  </tr>

                  {/* Footer */}
                  <tr>
                    <EmailFooterV2 variant="clean" showContactInfo={true} />
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
